import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import has from 'lodash/has';
import { IAppState } from '../../../../state/reducers';
import { IDispatchProps, IProps, IStateProps } from './interfaces';
import {
  Container,
} from './styles';
import MediaContent from './MediaContent/component';
import OperationsArea from './OperationsArea/component';
import { AssetDetails } from '../../../Shared/AssetDetails';
import { selectRenderableAssetDetails, resetActiveAsset, addAssetUpdates } from '../../../../state/exchange/activeAsset';

class ExchangeAssetDetails extends PureComponent<IProps> {
  onFieldChange = (value: any) => {
    this.props.addAssetUpdates(value);
  };

  render() {
    const {
      rawAssetDetails,
      assetDetails,
      editableAssetDetails,
      isEditable,
      onUseAsUpdate,
    } = this.props;

    return (
      <Container data-tip="Asset Details" className="AssetDetails">
        <MediaContent />
        {rawAssetDetails && <OperationsArea />}
        <AssetDetails
          isLoaded={!_.isEmpty(rawAssetDetails)}
          assetDetails={isEditable ? editableAssetDetails : assetDetails}
          rawAssetDetails={rawAssetDetails}
          isAssetEditable={isEditable}
          onUseAsUpdate={onUseAsUpdate}
          onFieldChange={this.onFieldChange}
        />
      </Container>
    );
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  rawAssetDetails: state.exchange.activeAsset.rawAssetDetails,
  isEditable: state.exchange.activeAsset.isEditable,
  assetDetails: selectRenderableAssetDetails(state),
  editableAssetDetails: state.exchange.activeAsset.editableAssetDetails,
  onUseAsUpdate: resetActiveAsset,
});

const mapDispatchToProps: IDispatchProps = { addAssetUpdates };

export default connect(mapStateToProps, mapDispatchToProps)(ExchangeAssetDetails);
